import axios from 'axios';
import { error } from '@/utils/logger';

const API_URL = process.env.NEXT_PUBLIC_APP_API_BASE_URL;
const APNS_TOKEN_ENDPOINT = `${API_URL}/api/v1/user/apns_token`;

export async function registerApnsToken(token: string): Promise<void> {
  await axios.post(APNS_TOKEN_ENDPOINT, { apns_token: token.toLowerCase() });
}

export async function deregisterApnsToken(): Promise<void> {
  try {
    await axios.post(APNS_TOKEN_ENDPOINT, { apns_token: null });
  } catch (err) {
    error('[pushNotifications] Failed to deregister APNS token', err);
    throw err;
  }
}
